import { gql } from "@apollo/client";

export const GET_WORKSPACES_LIST = gql`
  query GetWorkspacesList($input: WorkspacesInput!) {
    workspaces(input: $input) {
      edges {
        node {
          mrn
          name
        }
      }
    }
  }
`;
